import { Controller } from 'stimulus';

export default class PersonalDetailsController extends Controller {
  static targets = ['form', 'checkbox'];

  connect() {
    if (this.checkboxTarget.checked) {
      return this.formTarget.classList.remove('hidden');
    }

    this.formTarget.classList.add('hidden');
  }

  toggleForm() {
    this.formTarget.classList.toggle('hidden');
  }
}
